/**
 * all.js
 * Written by: Alex Kasemir
 */
import { createSelector } from 'reselect';

const all = createSelector(
  [
    (state) => state.badge.allKeys,
    (state) => state.badge.byKey,
  ],
  (allKeys, byKey) => {
    return allKeys.map((id) => byKey[id]);
  },
);

export default all;
